<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="日期" prop="currentData">
          <el-input v-model="dataForm.currentData" placeholder="日期"></el-input>
      </el-form-item>
          <el-form-item label="渠道id" prop="channelId">
          <el-input v-model="dataForm.channelId" placeholder="渠道id"></el-input>
      </el-form-item>
          <el-form-item label="产品id" prop="productId">
          <el-input v-model="dataForm.productId" placeholder="产品id"></el-input>
      </el-form-item>
          <el-form-item label="收费模式" prop="chargingmode">
          <el-input v-model="dataForm.chargingmode" placeholder="收费模式"></el-input>
      </el-form-item>
          <el-form-item label="买入单价" prop="buyPrice">
          <el-input v-model="dataForm.buyPrice" placeholder="买入单价"></el-input>
      </el-form-item>
          <el-form-item label="卖出单价" prop="salePrice">
          <el-input v-model="dataForm.salePrice" placeholder="卖出单价"></el-input>
      </el-form-item>
          <el-form-item label="卖出总数量" prop="saleNum">
          <el-input v-model="dataForm.saleNum" placeholder="卖出总数量"></el-input>
      </el-form-item>
          <el-form-item label="当日收入" prop="totalSalePrice">
          <el-input v-model="dataForm.totalSalePrice" placeholder="当日收入"></el-input>
      </el-form-item>
              <el-form-item label="更新者" prop="updater">
          <el-input v-model="dataForm.updater" placeholder="更新者"></el-input>
      </el-form-item>
          <el-form-item label="更新时间" prop="updateDate">
          <el-input v-model="dataForm.updateDate" placeholder="更新时间"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        currentData: '',
        channelId: '',
        productId: '',
        chargingmode: '',
        buyPrice: '',
        salePrice: '',
        saleNum: '',
        totalSalePrice: '',
        creator: '',
        createDate: '',
        updater: '',
        updateDate: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        currentData: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channelId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        chargingmode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        buyPrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        salePrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        saleNum: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalSalePrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updater: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/channelorderreport/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/channelorderreport/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
